module.exports = __webpack_public_path__ + "img/icon-category.f1e2afed.svg";